export default __webpack_public_path__ + "static/media/lock.e4567449.svg";